import gql from 'graphql-tag';

/**
 * Data of the block project-invoice-approval ("Rechnungen: Freigabe"): the approval state of the
 * employer and its note. Read through `Project.blocks.invoiceApproval`, which checks the block's
 * read permission.
 */
export const PROJECT_INVOICE_APPROVAL_FIELDS = gql`
  fragment projectInvoiceApprovalFields on ProjectInvoiceApprovalBlock {
    id
    number
    invoiceApprovementNote
    invoiceApprovementVerificationState
  }
`;
